export default __webpack_public_path__ + "static/media/budget-tracker.3707df73.png";